import { Plan, PlanName } from '~/hooks/usePlans'

/** Whether the current plan ranks at or above the required one; false until both are known. */
export const meetsPlan = ({
  plans,
  current,
  required,
}: {
  plans: Plan[]
  current: PlanName | undefined
  required: PlanName
}) => {
  const rankOf = (name: PlanName | undefined) =>
    plans.find((plan) => plan.name === name)?.rank
  const currentRank = rankOf(current)
  const requiredRank = rankOf(required)

  return (
    currentRank !== undefined &&
    requiredRank !== undefined &&
    currentRank >= requiredRank
  )
}
